import { observable } from "mobx";
import { Type } from "class-transformer";
import CardNumberSearchRequest from "./cardNumberSearchRequest";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import TerminalType from "./terminalType";
import type { EntityValidationRules } from "services/validationService";
import { startOfEDAZEshop } from "config";
import { addDays } from "date-fns";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SearchPayGatePaymentsRequest {
  @observable
  @Type(() => CardNumberSearchRequest)
  cardNumber?: CardNumberSearchRequest;

  /**
   * Variable symbol.
   */
  @observable
  variableSymbol?: number;

  /**
   * Auth code.
   */
  @observable
  authCode?: string;

  /**
   * Arn.
   */
  @observable
  arn?: string;

  /**
   * Payment ident.
   */
  @observable
  paymentIdent?: string;

  @observable
  terminalType?: TerminalType;

  @observable
  @Type(() => DecimalRangeRequest)
  amount?: DecimalRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  statementDate?: DateRangeRequest;

  @observable
  _cardNumberFirst?: string;

  @observable
  _cardNumberSecond?: string;
}

const oneOfRequiredForRequest = (entity: SearchPayGatePaymentsRequest) => {
  return (
    !entity._cardNumberFirst &&
    !entity._cardNumberSecond &&
    !entity.variableSymbol &&
    !entity.authCode &&
    !entity.variableSymbol &&
    !entity.arn &&
    !entity.paymentIdent
  );
};

const customMessage = "oneOfAttributesIsRequired";

export const SearchPayGatePaymentsRequestValidationRules: EntityValidationRules<SearchPayGatePaymentsRequest> = {
  variableSymbol: {
    isLength: {
      max: 10,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  authCode: {
    isLength: {
      max: 6,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  arn: {
    isLength: {
      max: 40,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  paymentIdent: {
    isLength: {
      max: 20,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  _cardNumberFirst: {
    isLength: {
      min: 6,
      max: 6,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  _cardNumberSecond: {
    isLength: {
      min: 2,
      max: 4,
      optional: true,
    },
    requiredIf: {
      condition: oneOfRequiredForRequest,
      customMessage: customMessage,
    },
  },
  amount: {
    isNumberRange: {
      min: 0,
    },
  },
  statementDate: {
    isDateRange: {
      min: startOfEDAZEshop,
      max: addDays(new Date(), 1),
    },
  },
};
